import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LcsSpinButtonComponent } from './spin-button.component';

@NgModule({
   imports: [CommonModule, MatButtonModule, MatIconModule, FormsModule],
   declarations: [LcsSpinButtonComponent],
   exports: [LcsSpinButtonComponent],
})
export class LcsSpinButtonModule {}
